import React from 'react';
import './TeamSection.css';
import SantiagoPhoto from './santiago.jpg'; // Asegúrate de que la imagen esté en la misma carpeta

const TeamSection = () => {
  return (
    <section className="team-section" id="team-section">
      <div className="container text-center">
        <h2 className="team-title">Conoce a nuestro fundador</h2>
        <p className="team-intro">
          Liderando con visión y pasión, Santiago Weinstein es el corazón detrás de SBK Soluciones Digitales.
        </p>
        <div className="team-member">
          <div className="photo-container">
            <img
              src={SantiagoPhoto}
              alt="Santiago Weinstein"
              className="team-photo"
            />
          </div>
          <h3 className="team-name">Santiago Weinstein</h3>
          <p className="team-role">Fundador y Desarrollador Full Stack</p>
          <p className="team-description">
            Ingeniero Civil Industrial con un enfoque en la tecnología y la innovación. Santiago combina su experiencia en desarrollo web y móvil con su visión estratégica para liderar proyectos que transforman ideas en soluciones digitales de alto impacto.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
